<template>
<md-layout>
    <md-layout md-flex="70">
        <md-toolbar class="md-transparent ql-project-header">
            <div class="project-toggles">
                <span class="dark-mode-toggle">
                    <md-switch v-model="localShowMode" id="showMode" name="showMode" @change="toggleShowMode">Dark Mode</md-switch>
                </span>
                <span class="project-lock-toggle" v-if="isOwner">
                    <md-switch v-model="localLocked" id="locked" name="locked" @change="toggleLocked">Project Lock</md-switch>
                </span>
            </div>
            <project-pagination class="ql-project-header-pull-right"
                :totalPages="totalPages" 
                :currentPage="currentPage" 
                @pageUp="pageUp" 
                @pageDown="pageDown" 
                @setPage="setPage"/>            
        </md-toolbar>
    </md-layout>
    <md-layout md-flex="30">
        <md-toolbar class="md-transparent ql-project-header">
            <span style="flex: 1"></span>
<!--             <md-button class="md-raised" @click="expandAll">
                <md-icon class="md-hide-medium">zoom_in</md-icon>
                Expand
                <md-tooltip>Expand all cues</md-tooltip>
            </md-button>
            <md-button class="md-raised" @click="contractAll">
                <md-icon class="md-hide-medium">zoom_out</md-icon>
                Contract
                <md-tooltip>Contract all cues</md-tooltip>
            </md-button> -->
            <span v-if="isActivePay" class="ql-project-role">Collaborator</span>
            <span v-else class="ql-project-role">Observer</span>
        </md-toolbar>
    </md-layout>
</md-layout>
</template>

<script>
import ProjectPagination from '@/components/project/pagination';

const ProjectHeader = {
    name: 'projectHeader',
    props: [
        'currentPage',
        'totalPages',
        'showMode',
        'locked',
        'isOwner',
        'isActivePay'
    ],
    data: function() {
        return {
            localShowMode: this.$props.showMode,
            localLocked: this.$props.locked
        };
    },
    watch: {
        locked() {
            this.localLocked = this.locked;
        }
    },
    methods: {
        pageDown() {
            this.$emit('pageDown', this.currentPage);
        },
        pageUp() {
            this.$emit('pageUp', this.currentPage);
        },
        setPage(number) {
            this.$emit('setPage', number);
        },
        toggleShowMode() {
            this.$emit('toggleShowMode');
        },
        toggleLocked() {
            this.$emit('toggleLocked');
        },
        expandAll() {
            console.log('Expanding all');
        },
        contractAll() {
            console.log('Contracting all');
        }
    },
    components: {
        'project-pagination': ProjectPagination
    }
};

export default ProjectHeader;
</script>

<style lang="scss">
.ql-project-header {
    width: 100%;
}
.ql-project-header-pull-right {
    display: inline-block;
    float: right;
}

.project-toggles {
    flex: 1;

    .md-switch {
        &.md-checked {
            .md-switch-container {
                background-color: darken(#5ecfdf, 30%) !important;

                .md-switch-thumb {
                    background-color: #5ecfdf;
                }
            }
        }
        label {
            font-weight: 100;
        }
    }
}

.dark-mode-toggle {
    margin-right: 10px;
    .md-ink-ripple {
        color: #5ecfdf !important;
    }
}

.ql-project-role {
    font-weight: 100;
    font-size: 14px;
    margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// header.vue?45fe923b